<template>
  <el-main :style="{height:height+'px'}" >
    <div class="Scroll_content">
      <div>

        <div v-if="lessonData.length != 0"> 

          <div v-for="(item,index) in lessonData" :key="index">
            <div class="title_older">{{item.title}}</div>
              <div class="list_content" v-for="(items,index) in item.list" :key="index">
              <div class="left_content">
                <div class="time_text">
                  <div class="title_content">{{items.subject_title}}</div>
                  <div class="timecontent">
                    {{items.start_time}} - {{items.end_time}}
                  </div>
                </div>  
              </div> 
              <div class="content_box">
                
                <div class="title_content_bom">  
                  <div class="dom">
                    <p>{{$t('new_test3.Level')}}</p> <span>{{items.level_title}}</span></div>  
                  <div class="dom">
                    <p>{{$t('new_test3.Topic')}}</p> <span>{{items.lesson_topic?items.lesson_topic:'-'}}</span></div>  
                </div>
                <div class="send_botton">
                  <div class="sinder_bun">
                    <div class="bunmerr" @click="viewFee(items.comments_id)" v-if="items.comments_status">{{$t('main.viewFeedback')}}</div> 
                    <div class="bunmer" @click="leaveFee(items)" v-else>{{$t('main.leaveFeeback')}}</div> 
                  </div>
                </div> 
              </div>
            </div>
          </div>
  
        </div>



        <div v-else class="noResultInfo">
          <p class="font_24_reg">{{$t('tabBar.noLesson')}}</p>
          <p class="font_24_reg">{{$t('tabBar.download')}}</p>
          <div class="flex_justify_center">
            <img @click="utils.toAppStore()" src="../../assets/Download_App_Store.svg" style="margin-right: 20px;" />
            <img @click="utils.toGooglePlay()" src="../../assets/google-play-badge.png" />
          </div>
        </div>

      <div class="dian"></div>
      </div>






    <div v-if="isShowLeave" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title center">
            <b>{{$t('main.leaveFeeback')}}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseImg">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>{{$t('main.rating')}}</p>
              <div class="starList">
                <el-rate v-model="LeaveScore"
                :allow-half="true"
                void-color="#FF9F43"
                ></el-rate>
                <!-- <p v-for="(item, i) in scoreArray" :key="i" @hover="changeScore($event)">
                  <img class='star'
                  :src="LeaveScore > i ? (LeaveScore - i == 0.5  ?  callStarUrl : fullStarUrl)  : nullStarUrl" />
                </p> -->
              </div>
              <p>{{$t('main.comment')}}</p>
              <textarea :placeholder="$t('main.commentHere')" v-model="addComment"></textarea>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary" @click="submitSick">
            <span>{{$t('main.send')}}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- 查看评论 -->
    <div v-if="isShowView" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title center">
            <b>{{$t('main.leaveFeeback')}}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseview">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>{{$t('main.rating')}}</p>
              <div class="starList">
                <el-rate
                  v-model="viewData.rating"
                  disabled
                disabled-void-icon-class="none_icon">
                </el-rate>
                <!-- <p v-for="(item, i) in scoreArray" :key="i">
                  <img class='star'
                  :src="viewData.rating > i ? viewData.rating - i == 0.5  ?  callStarUrl : fullStarUrl  : nullStarUrl" />
                </p> -->
              </div>
              <p>{{$t('main.comment')}}</p>
              <p class="pl">{{viewData.comment}}</p>
            </div>
          </div>
        </div>
        <!-- <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary" @click="submitSick">
            <span>Send</span>
          </button>
        </div> -->
      </div>
    </div>





    </div>
  </el-main>
  
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from '../views/header'
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'

  export default {
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    data () {
      return {
        searchStudentSn:"",
        height:100,
        lessonData:[],
        pagesize:'',
        page:'',


        lessondata: {},
        addComment: '',
        isShowLeave: false,
        isShowView: false,
        viewData: {},
        LeaveScore: 0, // 评分星星级别
        clickNum: 1,
        scoreArray: [1, 2, 3, 4, 5], // 分为1-5个评分层次
        fullStarUrl: require('../../assets/ant-design_star-filled.svg'), // 满星图片
        nullStarUrl: require('../../assets/ant-design_star-outlined.svg'), // 空星图片
        callStarUrl: require('../../assets/bx_bxs-star-half.svg') // 半星图片

      }
    },
    created () {
      let height = document.body.offsetHeight-80;
      this.height = height
      // console.log(1111,height);
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.getLesson();
      if (this.$route.query.type == 1) {
        this.activeTitle = 'course'
      } else {
        this.activeTitle = 'schedule'
      }
    },
    methods: {
      /**
       * 获取已完成课程
       */
      getLesson () {
        let children_id = getStore(keys.userProfile);
        // children_id.last_student_sn
        this.$http.get('/api/getCompletedLessonPCSeven?student_sn=' + children_id.last_student_sn + '&time_diff=' + this.utils.timeZone()+'&pagesize='+this.pagesize+'&page='+this.page).then((res) => {
          if (res.data.code == 200) {
            // console.log(999,res);
            let arr = res.data.data;

            for(var i=0;i<arr.length;i++){
              arr[i].list = [];
              arr[i].list.push(arr[i].data);
            }

            // console.log(arr);


            this.lessonData = arr;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },

      /**
       * 原始代码复制模块
       */
          leaveFee (item) {
            this.lessondata = item
            this.isShowLeave = !this.isShowLeave
            this.LeaveScore = 0
          },
          viewFee (comments_id) {
            this.$http.get('/api/getComment?comment_id=' + comments_id).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                this.isShowView = !this.isShowView
                this.viewData = res.data.data
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
          },
          chooseview () {
            this.isShowView = !this.isShowView
          },
          chooseImg () {
            this.isShowLeave = !this.isShowLeave
          },
          submitSick () {
            if (this.addComment == '' || this.LeaveScore == 0) {
              this.$message({
                message: 'Please give feedback',
                type: 'warning'
              })
              return false
            }
            this.$http.post('/api/setComment', {
              lesson_sn: this.lessondata.lesson_sn,
              student_sn: this.lessondata.student_sn,
              comment: this.addComment,
              rating: this.LeaveScore
            }).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                this.isShowLeave = !this.isShowLeave
                this.$notify({
                  message: this.$t('main.sendSuccess')
                })
                this.getLesson()
                // this.datalesson.map((item) => {
                //   if (item.lesson_sn == this.lessondata.lesson_sn && item.student_sn == this.lessondata.student_sn && res.data.status) {
                //     item.comments_status = true
                //   }
                // })
                // this.$forceUpdate()
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
          },
          getLessonn () {
            let searchChild = getStore(keys.searchFilter)
            this.$http.get('/api/getCompletedLessonPC?student_sn=' + searchChild + '&time_diff=' + this.utils.timeZone()).then((res) => {
              if (res.data.code == 200) {
                console.log(res)
                this.datalesson = res.data.data
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
          }
    },
    mounted () {
      // window.onresize = () => {
      //   let height = document.body.offsetHeight-83;
      //   this.height = height
      //   console.log(1111,height);
      // }
    },
    watch: {
      '$intercom.visible': function (val) {
        if (val == true) {
          this.updateIntercom()
        }
      },
      email (email) {
        this.$intercom.update({email})
      }
    },
  }
</script>
<style lang="less" scoped>

.el-main{
  overflow: inherit;
}
.left_body_content{
    // width: 358px;
  // height: 900px;
  // border: 1px solid ;
  // position: fixed;
  // top: 84px;
  // bottom: 0;
  // background: #FCFCFF;
  // border: 1px solid red;
  .left_nav_content{
    width: 358px;
    height: 900px;
    // border: 1px solid ;
    position: fixed;
    top: 84px;
    bottom: 0;
    background: #FCFCFF;
  }
  .right_content{
    // width: 400px;
    // height: 400px;
    // border: 1px solid red;
    // margin-left: 358px;
  }
}


.Scroll_content{
  // width: 1012px;
  height: 400px;
  // border:1px solid red;
  .list_content{
    // height: 140px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.09);
    box-shadow: 0px 4px 26.64px rgba(0, 0, 0, 0.09);
    border-radius: 9px;
    box-sizing: border-box;
    margin-top: 17px;
    .left_content{
      // width: 147px;
      font-family: Sofia Pro;
      font-style: normal;
      border-bottom: 1px solid #E9E9E9;
      padding-bottom:10px;
      .time_text{
          font-size: 32px;
          margin: 12px 0 10px 33px;
          .title_content{
            font-family: Sofia Pro;
            font-style: normal;
            font-weight: 500;
            font-size: 24px;
            color: #000000;
            margin-bottom:10px;
          }
          .timecontent{
            display: flex;
            align-items: center;
            button{
              margin-left:30px;
            }
          }
      }
      // .inm_xim{
      //   font-family: 'element-icons';
      //   font-style: normal;
      //   font-weight: normal;
      //   font-size: 16px;
      //   line-height: 16px;
      //   color: #A5A5A5;
      //   text-align: center;
      //   margin-top: -35px;
      // }
    }
    .content_box{
      // width: 550px;
      // height: 90px;
      border: 0px solid red;
      // margin-top: 24px;
      margin:20px 40px 20px 33px;
      flex:1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title_content_bom{
        display: flex;
        // margin-left: 35px;
        // margin-top: 19px;
        .dom{
          // margin-right: 49px;
          p{
            font-size: 20px;
            color: #000000;
          }
          span{
            font-size: 16px;
            color: #6B6B6B;
            display: block;
            min-width:162px;
            margin-top:10px;
          }
        }
      }
      
      .send_botton{
        // width: 267px;
        // height: 136px;
        display: flex;
        margin-left:30px;
        
        .bunmer{
          width: 183px;
          height: 50px;
          background: #4B4EFC;
          border-radius: 6px;
          font-family: Sofia Pro;
          font-style: normal;
          font-weight: bold;
          font-size: 18px;
          line-height: 50px;
          align-items: center;
          text-align: center;
          color: #FFFFFF;
          margin-top: 16px;
          cursor: pointer;
        }
      }
    }
  }
}
  .title_older{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 27px;
    line-height: 27px;
    color: #000000;
    margin-top: 18px;
  }
  .el-message-box__title{
    font-family: Sofia Pro !important;
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 24px !important;
    line-height: 37px !important;
    text-align: center !important;

    // font-family: Sofia Pro-Regular;
    color: #000000 !important;
    text-align: center !important;
}

.bunmerr{
  width: 183px;
  height: 50px;
  // background: #4B69FE;
  border:1px solid #4B69FE;
  border-radius: 6px;
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 50px;
  align-items: center;
  text-align: center;
  color: #4B69FE;
  margin-top: 16px;
  cursor: pointer;
}
.el-message-box{
  background: #ffffff !important;
}
.el-message-box__message p {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 25px;
  /* identical to box height */


  color: #000000;
}
/deep/ .el-rate{
  height:50px;
  .el-rate__icon{
      font-size: 35px;
      color: #FF9F43!important;
  }
  .el-rate__icon.hover{
    transform: scale(1);
  }
  .el-icon-star-on:before {
    content:url("../../assets/ant-design_star-filled.svg")
  }
  .none_icon:before,.el-icon-star-off:before{
    content:url("../../assets/ant-design_star-outlined.svg")
  }
}
.starList{
  margin-left: 34px;
  margin-top:5px;
  margin-bottom:34.1px;
}
.el-message-box__message textarea{
      height: 90px !important;
      border: 1px solid #F2F2F2 !important;

      font-family: Sofia Pro !important;
      font-style: normal !important;
      font-weight: normal !important;
      font-size: 16px !important;
      line-height: 16px !important;
      /* identical to box height */


      color: #A5A5A5 !important;
}
.el-message-box__btns button{
  width: 311px !important;
  height: 60px !important;
  background: #4B69FE !important;
  border-radius: 50px !important;
  font-family: Sofia Pro !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 18px !important;
  line-height: 18px !important;
  /* identical to box height */
  border: 1px solid #4B69FE !important;
  // display: flex !important;
  align-items: center !important;
  text-align: center !important;
  letter-spacing: -0.01em !important;
  margin: 0 auto 0 auto;
  color: #FFFFFF !important;
}
.pl{
  margin-left: 14px;
  margin-top: 10px;
  font-family: Sofia Pro !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 16px !important;
  /* identical to box height */


  color: #000000 !important;
  margin-bottom:20px;
}
.icon_winm{
    position: relative;
    top: -2px;
    margin-right: 17px;
}
  .noResultInfo{
    margin-top:80px;
    text-align: center;
    p{
      margin-bottom:32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/children/ViewCompletedLessons.vue